var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import deprecated from 'react-prop-types/lib/deprecated';
import CardExpander from './CardExpander';

/**
 * The `CardActions` component is used for adding actions on your card.
 * The actions should be `FlatButton`s or `IconButton`s.
 *
 * This component can act as a `CardExpander`.
 */

var CardActions = function (_Component) {
  _inherits(CardActions, _Component);
  function CardActions() {
    _classCallCheck(this, CardActions);
    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }
  CardActions.prototype.render = function render() {
    var _props = this.props,
      className = _props.className,
      children = _props.children,
      isExpander = _props.isExpander,
      expander = _props.expander,
      centered = _props.centered,
      stacked = _props.stacked,
      props = _objectWithoutProperties(_props, ['className', 'children', 'isExpander', 'expander', 'centered', 'stacked']);
    return React.createElement('section', _extends({}, props, {
      className: cn('md-dialog-footer--card', {
        'md-dialog-footer--inline': !stacked,
        'md-dialog-footer--stacked': stacked,
        'md-dialog-footer--card-centered': centered
      }, className)
    }), children, isExpander || expander && React.createElement(CardExpander, null));
  };
  return CardActions;
}(Component);
CardActions.propTypes = {
  /**
   * Boolean if this component should act as an expander and inject the
   * `CardExpander`.
   */
  expander: PropTypes.bool,
  /**
   * An optional className to apply to the actions container.
   */
  className: PropTypes.string,
  /**
   * An actions to display.
   */
  children: PropTypes.node,
  /**
   * Boolean if the actions should be centered.
   */
  centered: PropTypes.bool,
  /**
   * Boolean if the actions should be stacked.
   */
  stacked: PropTypes.bool,
  isExpander: deprecated(PropTypes.bool, 'Use `expander` instead')
};
export default CardActions;